import React, { useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSearchParams, convertURLSearchParamsToObject } from 'src/utils/useSearchParams';
import permissions from 'src/constants/permissions';
import useWithAuthorities from 'src/utils/useWithAuthorities';
import { postInviteUserToOrganizationAPI } from 'src/serverApi/organizationUsers';
import Modal from 'src/components/Modal';
import Text from 'src/components/Text';
import InviteUserForm from './InviteUserForm';

const InviteUserLink: React.FC = () => {
  const captchaRef = useRef<any>();
  const { organizationUeid } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const [isDialogOpen, setDialogOpen] = useState(searchParams.has('userEmail'));
  const [isLoading, setIsLoading] = useState(false);
  const [captchaError, setCaptchaError] = useState('');

  const withDataManagementAuthorities = useWithAuthorities([permissions.dataManagement]);

  const resetCaptcha = () => {
    captchaRef.current?.refresh();
  };

  const handleInviteUserClicked = (e: any) => {
    e.preventDefault();
    setDialogOpen(true);
  };

  const closeDialog = () => {
    if (searchParams.has('userEmail')) {
      const paramsObj = convertURLSearchParamsToObject(searchParams);
      delete paramsObj['userEmail'];
      setSearchParams(paramsObj);
    } else {
      setDialogOpen(false);
    }
  };

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      await withDataManagementAuthorities(async () => {
        await postInviteUserToOrganizationAPI(organizationUeid ?? '', values);
        // Отдельно вручную рефрешить каптчу здесь нет смысла, так как при последующем
        // открытии модалки отрендерится новая форма с новой каптчей
        closeDialog();
        toast.success('Приглашение отправлено');
      }, `${location.pathname}?${searchParams.toString()}&userEmail=${values.userEmail}`);
    } catch (error) {
      const { type } = error as any;
      if (type === 'INVALID_CAPTCHA') {
        setCaptchaError('Введённые символы не совпадают с изображением.');
      } else {
        toast.error('Ошибка отправки приглашения');
      }
      resetCaptcha();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <a href="#" onClick={handleInviteUserClicked}>
        Пригласить пользователя
      </a>
      <Modal
        isOpen={isDialogOpen}
        onClose={closeDialog}
        title="Приглашение пользователя"
        content={
          <>
            <Text type="p" muted>
              Для приглашения пользователя в организацию введите e-mail сотрудника. На электронную
              почту будет отправлено письмо со ссылкой на присоединение нового пользователя к
              организации.
            </Text>
            <InviteUserForm
              captchaRef={captchaRef}
              captchaError={captchaError}
              onSubmit={handleSubmit}
              isLoading={isLoading}
              onClose={closeDialog}
            />
          </>
        }
      />
    </>
  );
};

export default InviteUserLink;
